declare let THREE: any;

export class Axis extends (THREE.Line as { new(geometry, material): any; }) {

  static readonly Name = 'axis';

  constructor(size: number) {
    const material = new THREE.LineBasicMaterial({
      color: 0x0000ff
    });

    const geometry = new THREE.BufferGeometry().setFromPoints([
      new THREE.Vector3(-1, 0, 0),
      new THREE.Vector3(0, 0, 0),
      new THREE.Vector3(1, 0, 0)
    ]);
    super(geometry, material);
    this.name = Axis.Name;
    this.scale.x = size;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Angle/Axis.ts